


















module.exports = {
  props: ['prop_tooltip_placement']

  components:
    taskList: require('../manual_tasks/list')
    taskModalForm: require('../manual_tasks/modal_form')
    meetingModal: require('../shared/modals/meeting_modal')

  data: ->
    contact: null
    tasks: []
    filters:
      filter_by_contact_id: @$route.params.id
      done_at_null: true

    task_item_options:
      show_date: true
      icon_position: 'item'
      show_contact: false
      padding: 'sm'
      width: 'full-width'
    show_meeting_modal: false

  methods:
    reloadTasks: ->
      @$refs.task_list.reloadTasks()

    updateMetadata: (task) ->
      return if task.isDone()
      old_task = @tasks.find(task.id)
      if old_task
        old_task.metadata = task.metadata
        old_task.due_on = task.due_on
        @tasks.replaceById(old_task)

    contactLoaded: (data) ->
      @contact = data.contact

    taskCreated: (data) ->
      @$refs.task_list.addTask(data.task)
      alertify.success 'Tarefa adicionada com sucesso!'

    removeTask: (data) ->
      @$refs.task_list.removeTask(data.task)
      @$emit('task-destroyed', data)
      alertify.success 'Tarefa excluída com sucesso!'

    eventTaskUndone: (task) ->
      @$refs.task_list.addTask(task)

    editTask: (data) ->
      @openModalForm(data.task.id)

    newTask: ->
      @openModalForm()

    openModalForm: (task_id) ->
      EventsBus.$emit 'TaskModalForm::Show', { task_id: task_id, contact: null, id: 'manual-task-form-modal' }

    taskSort: (task_1, task_2) ->
      task_1_done = task_1.isDone()
      task_2_done = task_2.isDone()

      if (task_1_done and task_2_done) or (!task_1_done and !task_2_done)
        return task_1.due_on.isAfter(task_2.due_on) and 1 or -1
      else if task_1_done
        return 1
      else if task_2_done
        return -1

    openMeetingModal: (data) ->
      @selected_task = data.task
      @show_meeting_modal = true

    closeMeetingModal: ->
      @selected_task = new Task
      @show_meeting_modal = false

  mounted: ->
    EventsBus.$on 'contact-loaded', @contactLoaded
    EventsBus.$on 'Task::Created', @taskCreated
    EventsBus.$on 'Task::New', @newTask
    EventsBus.$on 'Task::EventUndone', @eventTaskUndone
    EventsBus.$on 'Task::UpdatedMetadata', @updateMetadata
    EventsBus.$on 'meeting-modal-show', @openMeetingModal

  beforeDestroy: ->
    EventsBus.$off 'contact-loaded', @contactLoaded
    EventsBus.$off 'Task::Created', @taskCreated
    EventsBus.$off 'Task::New', @newTask
    EventsBus.$off 'Task::EventUndone', @eventTaskUndone
    EventsBus.$off 'Task::UpdatedMetadata', @updateMetadata
    EventsBus.$off 'meeting-modal-show', @openMeetingModal
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/contacts/tasks.vue